<template>
    <button
        v-tippy="t('editorAddRowAfter')"
        :class="[buttonState(editor.can().addRowAfter()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().addRowAfter()"
        @click="editor.chain().focus().addRowAfter().run()"
    >
        <MdiTableRowPlusAfter class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableRowPlusAfter from 'materialdesignicons-vue3/icons/MdiTableRowPlusAfter.js';

    defineExpose({
        name: 'AddTableRowAfterButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
